<template>
  <div class="event-card-loader">
    <div class="event-card-loader__background mb-2">
      <div
        class="d-flex flex-row justify-space-between event-card-loader__discipline"
      >
        <div
          class="event-card-loader__line mb-0"
          style="width: 10%;height: 18px;"
        />
        <div
          class="event-card-loader__line mb-0"
          style="width: 10%;height: 18px"
        />
      </div>
      <v-row
        v-if="$vuetify.breakpoint.mdAndUp"
        no-gutters
        class="event-card-loader__content"
      >
        <v-col col="7">
          <div class="event-card-loader__line" style="width: 70%" />
          <br />
          <div class="event-card-loader__line" style="width: 50%" />
          <div class="event-card-loader__line" style="width: 35%" />
          <br />
          <div class="event-card-loader__line" style="width: 35%" />
          <br />

          <div
            class="event-card-loader__line"
            style="width: 35%;position: relative;bottom: -4px;"
          />
        </v-col>

        <v-col col="5">
          <div
            class="d-flex"
            style="justify-content: flex-end;position: relative; bottom: -10px;"
          >
            <div class="event-card-loader__logo" />
          </div>
          <br />
          <br />
          <div
            class="d-flex"
            style="justify-content: flex-end;position: relative;bottom: -77px;"
          >
            <div class="event-card-loader__icon" />
            <div class="event-card-loader__icon" />
            <div class="event-card-loader__icon" />

            <div class="event-card-loader__icon" />
          </div>
        </v-col>
      </v-row>
      <v-row v-else class="px-4 py-2">
        <v-col cols="12">
          <div class="event-card-loader__line" style="width: 250px" />
          <div class="event-card-loader__line" style="width: 170px" />
        </v-col>

        <v-col :class="[$vuetify.breakpoint.lgAndUp ? 'px-4' : 'px-2', 'my-3']">
          <v-row align="center">
            <v-col cols="5">
              <div class="event-card-loader__logo" />
            </v-col>

            <v-col cols="7">
              <br />
              <div class="event-card-loader__line" style="width: 67%" />
              <div class="event-card-loader__line" style="width: 56%" />
            </v-col>
          </v-row>

          <v-col justify="center" style="display: grid;">
            <div class="event-card-loader__line" style="width: 240px" />
            <div class="event-card-loader__line ma-auto" style="width: 210px" />
          </v-col>

          <v-col justify="center" style="display: grid;">
            <div class="event-card-loader__line" style="width: 180px" />
            <div class="event-card-loader__line" style="width: 180px" />
            <div class="event-card-loader__line" style="width: 180px" />
          </v-col>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "EventCardPlaceholder",
  mounted() {
    const options = {
      thereshold: 0.85,
      root: null
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Cleanup the observer when it's not
          // needed anymore.
          observer.unobserve(this.$el);
          this.$el.classList.add("loading-animation");
        }
      });
    }, options);
    // We observe the root `$el` of the
    // mounted loading component to detect
    // when it becomes visible.
    observer.observe(this.$el);
  }
};
</script>
<style lang="scss">
.event-card-loader {
  max-width: 1110px;
  width: 100%;
  min-height: 300px;

  @media (max-width: 959px) {
    max-width: 355px;
    margin: 12px auto;
  }

  &__discipline {
    background: grey;
    height: 38px;
    border-radius: 5px;
    padding: 0 20px;
    align-items: center;
    z-index: 0;
  }

  &__content {
    max-width: 1110px;
    min-height: 270px;
    margin: auto;
    transform: translateY(-3px);
    z-index: 1;
    background: white;
    border-radius: 5px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24);
    padding: 20px 30px;
  }
  &__logo {
    width: 80px;
    height: 80px;
    margin: 0 40px;
    border-radius: 24em;
    background-color: rgba(230, 230, 230);
    display: block;
    @media (max-width: 959px) and (min-width: 600px) {
      width: 80px;
      height: 80px;
    }
  }

  &__line {
    width: 100%;
    min-height: 24px;
    padding: 0 8px;
    margin-bottom: 8px;
    background-color: rgba(230, 230, 230);
    border-radius: 12px;
  }

  &__icon {
    padding: 12px 20px;
    background-color: rgba(230, 230, 230);
    border-radius: 24em;
    margin: 0 8px;
    @media (max-width: 959px) {
      padding: 6px 15px;
    }
  }
}
.loading-animation {
  animation-name: event-card-loading;
  animation-duration: 0.25s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
}
@keyframes event-card-loading {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.85;
  }
}
</style>
